// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dmpK","col":"styles_col__3N1w4","actions":"styles_actions__2hyiq","conflict":"styles_conflict__2mXRE"};